export function round(value: number, precision: number = 2): number {
  return Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision);
}

export function trunc(value: number, precision: number = 0): number {
  return Math.trunc(value * Math.pow(10, precision)) / Math.pow(10, precision);
}
